export default "__VITE_ASSET__9c3575ea__"